import type React from "react";

import useMetricsPreloading from "@/components/DataPreloader/hooks/useMetricsPreloading";

const MetricsPreloader: React.FC = () => {
  useMetricsPreloading();

  return null;
};

export default MetricsPreloader;
